import { render } from "./single-listing.vue?vue&type=template&id=beda27fa"
import script from "./single-listing.vue?vue&type=script&lang=js"
export * from "./single-listing.vue?vue&type=script&lang=js"

import exportComponent from "C:\\MAMP\\htdocs\\vetpartners\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/vacancies/listing/single-listing.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "beda27fa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('beda27fa', __exports__)) {
    console.log('reload')
    api.reload('beda27fa', __exports__)
  }
  
  module.hot.accept("./single-listing.vue?vue&type=template&id=beda27fa", () => {
    console.log('re-render')
    api.rerender('beda27fa', render)
  })

}


export default __exports__